(function() {

  angular
    .module('meanApp')
    .factory('confirmationModal', ['$uibModal',
    function ($uibModal) {
        return {
            open : function(scopeParam, controllerParam) {
                $uibModal.open({
                  templateUrl: 'common/factories/confirmation.modal.view.html',
                  controller: controllerParam,
                  controllerAs: 'vm',
                  scope : scopeParam
                });
            }
        };
    }]);

})();